angular.module("Main").controller("PaymentTerminCancelFailErrorController", ["$rootScope", "$scope", "$state", "$stateParams", "$location", "$translate", "PaymentService", "BookingService", "SessionService",
    function ($rootScope, $scope, $state, $stateParams, $location, $translate, PaymentService, BookingService, SessionService) {
        var vm = this;

        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate');
            //unregisterEventHandler();
            $state.go('angebot', {cid: $stateParams.cid, id: $stateParams.id});

        });
        BookingService.getCurrency().then(function (data) {
            vm.currency = data;
            if (vm.currency.Waehrung === "EUR")
                vm.currency.Waehrung = "€";
        });

        $scope.$on("destroy", function () {
            logoutHandler();
        });
        vm.clubId = SessionService.getAuthData();

        if ($stateParams.message)
            vm.message = $stateParams.message;

        vm.isKurs = false;
        vm.isTermin = true;

        getKursbuchungLayouKonfiguration();


        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        if (!SessionService.getSessionId()) {
            $state.go("angebot", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        } else
            init();


        function init() {
            vm.hasError = false;

            BookingService.getMeetingData($stateParams.oid).then(function (data) {

                vm.meetingData = ({
                    Name: data.booking.Artikel,
                    Preis: data.booking.Preis,
                    Day: data.booking.Start,
                    End: data.booking.Ende,
                    Start: data.booking.Start,
                    RessourcenIds: data.booking.RessourcesIds,
                    RIds: data.booking.RessourcesIds,
                    TerminNr: data.booking.TerminNr,
                    TerminartNr: data.booking.TerminartNr,
                    Dauer: data.booking.Dauer,
                    Bezahlung: data.type.Bezahlung
                });

                SessionService.setAppointment(vm.meetingData.TerminartNr, vm.meetingData);
            });
            BookingService.deleteMemberFromAppointment($stateParams.oid).then(function () {
                PaymentService.cancelPayment($stateParams.rid).then(function () {
                    if (!_.isNil($stateParams.oid))
                        BookingService.cancelReservation($stateParams.oid, $translate.use(), 'ERROR');
                }).catch(function () {
                    vm.hasError = true;
                });
            }).catch(function () {
                vm.hasError = true;
            });
        }

    }]);
